import { DataLayer } from '@grandvisionhq/analytics';
import { getProductDetailEventTrackingAttributes } from '../utils/ProductMapper.js';

const variantClickEvent = (event_type, product)=>({
        event_type,
        event: 'gvProductClick',
        event_category: product.type,
        click_type: 'variation click',
        product
    })
;
const pushEvent = (event)=>DataLayer.pushEvent(event)
;
const ProductAnalyticsEvents = {
    pushPdpSunglassesRxSelectionEvent: (withRx)=>{
        const eventLabel = !!withRx ? DataLayer.DataLayerTypes.GlassLensPrescriptionType.Prescription : DataLayer.DataLayerTypes.GlassLensPrescriptionType.NonPrescription;
        DataLayer.pushEvent({
            event: 'RxSunConfigEvent',
            eventAction: 'click on button',
            eventLabel
        });
    },
    pushPdpProductDetailEvent: (props)=>{
        const productEventTrackingAttributes = getProductDetailEventTrackingAttributes(props);
        DataLayer.pushEcommerceEvent({
            event: 'gvProductDetail',
            atfEcommerce: {
                ecommerce: {
                    currencyCode: props.currencyCode,
                    ['detail']: {
                        actionField: {
                            list: 'pdp'
                        },
                        products: [
                            productEventTrackingAttributes
                        ]
                    }
                }
            }
        });
    },
    pushPdpVariantClickEvent: (product)=>{
        const pdpVariantClickEvent = variantClickEvent('pdp', product);
        pushEvent(pdpVariantClickEvent);
    },
    pushPlpVariantClickEvent: (product)=>{
        const plpVariantClickEvent = variantClickEvent('plp', product);
        pushEvent(plpVariantClickEvent);
    }
};

export { ProductAnalyticsEvents };
//# sourceMappingURL=ProductAnalyticsEvents.js.map
